import React from 'react'
import { Box, Chip, Grid, TextField, Typography } from '@mui/material'
import moment from 'moment'
import CalenderSVG from 'assets/logo/Calendar'

const labelTextStyles = {
    fontFamily: 'Outfit',
    fontWeight: 500,
    fontSize: '16px',
    lineHeight: '100%',
    letterSpacing: "0px",
    mb: 1
};

const textInputStyles = {
    "& input::-webkit-calendar-picker-indicator": {
        display: "none",
        WebkitAppearance: "none",
    },
    "& input[type='date']": {
        appearance: "none",
        WebkitAppearance: "none",
    },
    "& .MuiOutlinedInput-root": {
        "& fieldset": {
            border: "none",
        },
    },
}

const calendarStyles = {
    backgroundColor: "#E7E7EB",
    height: "40px",
    width: { xs: "100%", md: "100%" },
    borderRadius: "5px",
    pl: "10px"
}



const WbsDateFilters = ({ values, setFieldValue }) => {
    return (
        <Grid container spacing={2}>
            <Grid size={6}>
                <Typography sx={labelTextStyles}>Start Date From</Typography>
                <DateField value={values?.startDateFrom} name="startDateFrom" handleDateChange={(e) => setFieldValue("startDateFrom", e.target.value)} />
            </Grid>
            <Grid size={6}>
                <Typography sx={labelTextStyles}>Start Date To</Typography>
                <DateField value={values?.startDateTo} name="startDateTo" handleDateChange={(e) => setFieldValue("startDateTo", e.target.value)} />
            </Grid>
            <Grid size={6}>
                <Typography sx={labelTextStyles}>End Date From</Typography>
                <DateField value={values?.endDateFrom} name="endDateFrom" handleDateChange={(e) => setFieldValue("endDateFrom", e.target.value)} />
            </Grid>
            <Grid size={6}>
                <Typography sx={labelTextStyles}>End Date To</Typography>
                <DateField value={values?.endDateTo} name="endDateTo" handleDateChange={(e) => setFieldValue("endDateTo", e.target.value)} />
            </Grid>
        </Grid>
    )
}

export default WbsDateFilters


const DateField = ({ value, name, handleDateChange }) => {
    return <TextField
        type="date"
        name={name}
        value={value}
        // onBlur={handleBlur}
        onChange={handleDateChange}
        onClick={(e) => {
            // Trigger the native date picker
            const input = e.currentTarget.parentElement?.querySelector('input[type="date"]');
            if (input) input.showPicker?.();
        }}
        fullWidth
        sx={textInputStyles}
        InputProps={{
            startAdornment: (
                <Box sx={{ ml: 0, mr: 1, color: "#433F5E", display: "flex", alignItems: "center", cursor: "pointer" }}

                >
                    {CalenderSVG}
                </Box>
            ),
            sx: calendarStyles,
        }}
    />
}